module.exports = __webpack_public_path__ + "img/bt.45ce8558.png";